import { render } from "./others-info.vue?vue&type=template&id=9b115d7c"
import script from "./others-info.vue?vue&type=script&lang=js"
export * from "./others-info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__